import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const FallbackBadge: React.FC<{ value: string }> = ({ value }) => {
  const displayValue = toPascalCase(value);
  return (
    <div
      css={css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: ${theme.spacing(3)};
        padding: ${theme.spacing(1)};
        border-radius: ${theme.borderRadius.small};
        font-size: ${theme.font.size.medium};
        font-weight: ${theme.font.weight.regular};
        line-height: ${theme.spacing(2.5)};
        background-color: ${theme.colors.neutral50};
        color: ${theme.colors.white};
        user-select: none;
      `}
    >
      {displayValue}
    </div>
  );
};

const toPascalCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
